// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import SectionNavController from "./section_nav_controller"
application.register("section-nav", SectionNavController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import ImageryFilterController from "./imagery_filter_controller"
application.register("imagery-filter", ImageryFilterController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import CardClickController from "./card_click_controller"
application.register("card-click", CardClickController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FileFieldController from "./file_field_controller"
application.register("file-field", FileFieldController)
